import $ from 'jquery' // jQuery

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

import counterUp from 'counterup2' // カウントアッププラグイン

import './_top.js'
import './_form.js'

import { gsap } from 'gsap'

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

$('.js-acc').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
})

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.activeを付加
// Intersection Observer
window.intObs = function (rootMargin) {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20%', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        if ($(entryItem).hasClass('js-count')) {
          // countUp($(entryItem), 1)
          counterUp(entryItem, {
            duration: 1200,
            delay: 16,
          })
        }
        if ($(entryItem).hasClass('js-count-f')) {
          // countUp($(entryItem), 10)
          counterUp(entryItem, {
            duration: 1200,
            delay: 16,
          })
        }
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if (!document.getElementById('page-top')) {
  window.intObs('-10% 0px')
} else {
  window.intObs('-50% 0px')
}

/*
   ######  #######  ##     ## ##    ## ######## ##     ## ########
  ##      ##     ## ##     ## ####  ##    ##    ##     ## ##     ##
  ##      ##     ## ##     ## ## ## ##    ##    ##     ## ########
  ##      ##     ## ##     ## ##  ####    ##    ##     ## ##
   ######  #######   #######  ##    ##    ##     #######  ##
*/
function countUp(countView, num) {
  const from = parseFloat(countView.attr('data-from'), 10)
  const to = parseFloat(countView.attr('data-to'), 10)
  $({ count: from }).animate(
    {
      count: to,
    },
    {
      duration: 1200,
      step: function () {
        countView.text(Math.ceil(this.count * num) / num)
      },
    }
  )
}

/*
  ##     ## ######## ##     ## ########  ######## ########
  #### #### ##       #### #### ##     ## ##       ##     ##
  ## ### ## ######   ## ### ## ########  ######   ########
  ##     ## ##       ##     ## ##     ## ##       ##   ##
  ##     ## ######## ##     ## ########  ######## ##     ##
*/
if ($('.js-swiper-member')[0]) {
  // eslint-disable-next-line no-unused-vars
  const memberSlide = new Swiper('.js-swiper-member', {
    speed: 1000,
    spaceBetween: 20,
    slidesPerView: 'auto',
    // loop: true,
    768: {
      spaceBetween: 40,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        //
      },
    },
  })
}

/*
  ##     ## #### ######## ##      ## ##     ##  #######  ########  ########
  ##     ##  ##  ##       ##  ##  ## #### #### ##     ## ##     ## ##
  ##     ##  ##  ######   ##  ##  ## ## ### ## ##     ## ########  ######
   ##   ##   ##  ##       ##  ##  ## ##     ## ##     ## ##   ##   ##
     ###    #### ########  ###  ###  ##     ##  #######  ##     ## ########
*/
$('.js-viewmore').on('click', function () {
  $(this).next().slideToggle()
  if ($(this).next().hasClass('flex')) {
    $(this).next().css('display', 'flex')
  }
  $(this).toggleClass('active')
  $('.js-viewmore-text').toggleClass('active')
})

$('.js-viewmore-prev').on('click', function () {
  $(this).prev().slideToggle()
  if ($(this).prev().hasClass('flex')) {
    $(this).prev().css('display', 'flex')
  }
  $(this).toggleClass('active')
  $('.js-viewmore-text').toggleClass('active')
})

/* マウスストーカー */
const stalker = document.getElementById('mouseStalker')
const linkElem = document.getElementsByClassName('js-footerlink')
if (window.matchMedia('(min-width:769px)').matches && linkElem[0]) {
  document.addEventListener('mousemove', function (e) {
    stalker.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)'
  })
  for (let i = 0; i < linkElem.length; i++) {
    linkElem[i].addEventListener('mouseover', function (e) {
      stalker.classList.add('hover')
    })
    linkElem[i].addEventListener('mouseout', function (e) {
      stalker.classList.remove('hover')
    })
  }
}

if (window.matchMedia('(min-width:769px)').matches && $('.js-footerEntry')[0]) {
  const pos = $('.footerEntry').offset().top - 300
  var o = 'expo.out'
  gsap.fromTo(
    '.js-footerEntry',
    {
      y: '80',
      scale: '.65',
    },
    {
      y: '0',
      scale: '1',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js-footerEntry',
        start: pos, // 開始位置
        end: pos + 500, // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
}
